var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k3tjnw5xja",
    d: "M0 0H26V26H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "fillColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5z62xk181b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k3tjnw5xja"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "fillColor",
    d: "M21.193 4.487c.38.379.382.995.003 1.375l-.003.003L7.478 19.522h10.17c.553 0 1 .448 1 1 0 .553-.447 1-1 1H5.964v.039H4.955c-.286 0-.544-.12-.726-.313-.192-.181-.312-.44-.312-.726v-1h.038V8.227c0-.552.448-1 1-1h.01c.552 0 1 .448 1 1l-.001 10.045L19.808 4.487c.383-.381 1.002-.382 1.385 0z",
    mask: "url(#5z62xk181b)",
    transform: "translate(12.698036, 12.880776) rotate(-315.000000) translate(-12.698036, -12.880776)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic_back.52482a1b.svg";
export { ForwardRef as ReactComponent };